import { render, staticRenderFns } from "./AnnonceCoop.vue?vue&type=template&id=797861d1&scoped=true&"
import script from "./AnnonceCoop.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnnonceCoop.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797861d1",
  null
  
)

export default component.exports